<template>
 <vue-element-loading :active="loading" :is-full-screen="true" spinner="spinner"  color="#007bff" />
</template>

<script>
	import {
		writeGaEvent
	} from "@/utils/ga";
	import {
		showDebugLog,
		displayPopupMessage
} from "@/utils/log";
import { getCookie, setCookie } from '@/utils/cookie'
import VueElementLoading from 'vue-element-loading'
	export default {
    name: "Logout",
    components: {VueElementLoading},
    data() {
        return {
            src: '',
            loading:false,
            isback:0,
        }},
    created() {
        
        if (this.$route.query.src) {
            setCookie('SRC', this.$route.query.src)
            this.src = getCookie('SRC') ?? ''
        } else {
            this.src = getCookie('SRC') ?? ''
        }
        if (this.$route.query.isback) {
    const isbackValue = this.$route.query.isback === '1' ? '1' : '0'; // 校验合法性
    setCookie('ISBACK', isbackValue);
  }
  this.isback = parseInt(getCookie('ISBACK')) || 0; // 确保为 Number 类型
  console.log('isback:', this.isback); // 调试输出
        this.Logout();
    },

    methods: {
        Logout() {
            this.loading = true;
            this.$store.dispatch("user/logout").then((res) => {
                if (this.src === '') 
                {
					window.location.href = process.env.VUE_APP_HOMEPAGE_URL
				} else {
                    if (this.isback === 1) {
                        window.location.href =this.src;
                    }else{
                        window.location.href = process.env.VUE_APP_LH_DOMAIN + (this.src? "?src=" + this.src : "");
                    }
                   
                }
              
            }).catch(err => {
                this.loading = false;
                showDebugLog("Login-API-error", err);
                displayPopupMessage(err, "error");
            }).finally(() => {
                 writeGaEvent(this, "Auth", "Logout", "", "");
                this.loading = false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
